import App from "../../services/App/App.js";
import AppModule from "../../services/App/AppModule.js";
import Info from "./PlosInfo.js";
import ModelBody from "./PlosModel_Body.js";

// formula: AccountingBased
export default {
  getSummary(transactionDetails, access, searchData) {
    let result = ModelBody.createSummary();

    let newTransRow;
    const summaryObj = this.getSummary_getTransactionSummary(transactionDetails);

    newTransRow = this.getSummary_getInvoice(summaryObj, access, searchData);
    result.TransactionList.push(newTransRow);

    newTransRow = this.getSummary_getInvoice_hppTotal(summaryObj, access, searchData);
    result.TransactionList.push(newTransRow);

    newTransRow = this.getSummary_getHppAdj(summaryObj, access, searchData);
    result.TransactionList.push(newTransRow);

    newTransRow = this.getSummary_getStockOpname(summaryObj, access, searchData);
    result.TransactionList.push(newTransRow);

    newTransRow = this.getSummary_getRtnInvoice(summaryObj, access, searchData);
    result.TransactionList.push(newTransRow);

    newTransRow = this.getSummary_getRtnInvoice_hppTotal(summaryObj, access, searchData);
    result.TransactionList.push(newTransRow);

    newTransRow = this.getSummary_getExpense(summaryObj, access, searchData);
    result.TransactionList.push(newTransRow);

    newTransRow = this.getSummary_getStockReduction(summaryObj, access, searchData);
    result.TransactionList.push(newTransRow);

    if (Object.prototype.hasOwnProperty.call(transactionDetails, "StockTrf")) {
      newTransRow = this.getSummary_getStockTrf(summaryObj, access, searchData);
      result.TransactionList.push(newTransRow);
    }

    // old
    for (const row of result.TransactionList) {
      if (row.AddTotal !== null) {
        result.Total += row.AddTotal;
      }

      if (row.SubTotal !== null) {
        result.Total -= row.SubTotal;
      }
    }

    return result;
  },
  getSummary_getTransactionSummary(transactionDetails) {
    let addTotal, subTotal, row;
    let summaryObj = {};

    // Invoice
    addTotal = 0;
    subTotal = null;
    for (row of transactionDetails.InvoiceList) {
      addTotal += row.Total;
    }
    addTotal = App.Data.getFixedDecimal(addTotal);

    summaryObj[AppModule.Invoice.Code] = {
      AddTotal: addTotal,
      SubTotal: subTotal
    };

    // Invoice (HppTotal)
    addTotal = null;
    subTotal = 0;
    for (row of transactionDetails.InvoiceHppList) {
      subTotal += row.Total;
    }
    subTotal = App.Data.getFixedDecimal(subTotal);

    summaryObj[AppModule.Invoice.Code + "HppTotal"] = {
      AddTotal: addTotal,
      SubTotal: subTotal
    };

    // HppAdj
    addTotal = 0;
    subTotal = null;
    for (row of transactionDetails.HppAdjList) {
      addTotal += row.Total;
    }
    addTotal = App.Data.getFixedDecimal(addTotal);

    summaryObj[AppModule.HppAdj.Code] = {
      AddTotal: addTotal,
      SubTotal: subTotal
    };

    // StockOpname
    addTotal = 0;
    subTotal = null;
    for (row of transactionDetails.StockOpnameList) {
      addTotal += row.Total;
    }
    addTotal = App.Data.getFixedDecimal(addTotal);

    summaryObj[AppModule.StockOpname.Code] = {
      AddTotal: addTotal,
      SubTotal: subTotal
    };

    // RtnInvoice
    addTotal = null;
    subTotal = 0;
    for (row of transactionDetails.RtnInvoiceList) {
      subTotal += row.Total;
    }
    subTotal = App.Data.getFixedDecimal(subTotal);

    summaryObj[AppModule.RtnInvoice.Code] = {
      AddTotal: addTotal,
      SubTotal: subTotal
    };

    // RtnInvoice (HppTotal)
    addTotal = 0;
    subTotal = null;
    for (row of transactionDetails.RtnInvoiceHppList) {
      addTotal += row.Total;
    }
    addTotal = App.Data.getFixedDecimal(addTotal);

    summaryObj[AppModule.RtnInvoice.Code + "HppTotal"] = {
      AddTotal: addTotal,
      SubTotal: subTotal
    };

    // Expense
    addTotal = null;
    subTotal = 0;
    for (row of transactionDetails.ExpenseList) {
      subTotal += row.Total;
    }
    subTotal = App.Data.getFixedDecimal(subTotal);

    summaryObj[AppModule.Expense.Code] = {
      AddTotal: addTotal,
      SubTotal: subTotal
    };

    // StockReduction
    addTotal = null;
    subTotal = 0;
    for (row of transactionDetails.StockReductionList) {
      subTotal += row.Total;
    }
    subTotal = App.Data.getFixedDecimal(subTotal);

    summaryObj[AppModule.StockReduction.Code] = {
      AddTotal: addTotal,
      SubTotal: subTotal
    };

    // StockTrf
    if (Object.prototype.hasOwnProperty.call(transactionDetails, "StockTrf")) {
      addTotal = 0;
      subTotal = 0;
      for (row of transactionDetails.StockTrf.AddList) {
        addTotal += row.Total;
      }
      addTotal = App.Data.getFixedDecimal(addTotal);

      for (row of transactionDetails.StockTrf.SubList) {
        subTotal += row.Total;
      }
      subTotal = App.Data.getFixedDecimal(subTotal);

      summaryObj[AppModule.StockTrf.Code] = {
        AddTotal: addTotal,
        SubTotal: subTotal
      };
    }

    return summaryObj;
  },
  getSummary_getInvoice(summaryObj, access, searchData) {
    const transSummary = summaryObj[AppModule.Invoice.Code];

    const addSearch = {
      Search: "",
      Client: "",
      ClientID: null,
      InvoiceDate: searchData.Date,
      Status: App.Search.OptionAll,
      WarehouseID: searchData.WarehouseID,
      RecordTypeID: App.Search.OptionAll
    };
    const addParams = ["Search", "Client", "ClientID", "InvoiceDate", "Status",
      "WarehouseID", "RecordTypeID"
    ];

    return this.getSummary_createTransRow(
      access.Invoice_Act_List, AppModule.Invoice.FullName, AppModule.Invoice,
      transSummary.AddTotal, addSearch, addParams,
      transSummary.SubTotal, null, null
    );
  },
  getSummary_getInvoice_hppTotal(summaryObj, access, searchData) {
    const transSummary = summaryObj[AppModule.Invoice.Code + "HppTotal"];

    const subSearch = {
      Search: "",
      Client: "",
      ClientID: null,
      InvoiceDate: searchData.Date,
      Status: App.Search.OptionAll,
      WarehouseID: searchData.WarehouseID,
      RecordTypeID: App.Search.OptionAll
    };
    const subParams = ["Search", "Client", "ClientID", "InvoiceDate", "Status",
      "WarehouseID", "RecordTypeID"
    ];

    return this.getSummary_createTransRow(
      access.Invoice_Act_List, Info.Transaction.InvoiceHpp, AppModule.Invoice,
      transSummary.AddTotal, null, null,
      transSummary.SubTotal, subSearch, subParams
    );
  },
  getSummary_getHppAdj(summaryObj, access, searchData) {
    const transSummary = summaryObj[AppModule.HppAdj.Code];

    const addSearch = {
      Search: "",
      Date: searchData.Date,
      WarehouseID: searchData.WarehouseID
    };
    const addParams = ["Search", "Date", "WarehouseID"];

    return this.getSummary_createTransRow(
      access.HppAdj_Act_List, AppModule.HppAdj.FullName, AppModule.HppAdj,
      transSummary.AddTotal, addSearch, addParams,
      transSummary.SubTotal, null, null
    );
  },
  getSummary_getStockOpname(summaryObj, access, searchData) {
    const transSummary = summaryObj[AppModule.StockOpname.Code];

    const addSearch = {
      Search: "",
      Date: searchData.Date,
      WarehouseID: searchData.WarehouseID
    };
    const addParams = ["Search", "Date", "WarehouseID"];

    return this.getSummary_createTransRow(
      access.StockOpname_Act_List, AppModule.StockOpname.FullName,
      AppModule.StockOpname, transSummary.AddTotal, addSearch, addParams,
      transSummary.SubTotal, null, null
    );
  },
  getSummary_getRtnInvoice(summaryObj, access, searchData) {
    const transSummary = summaryObj[AppModule.RtnInvoice.Code];

    const subSearch = {
      Search: "",
      ClientID: null,
      ClientName: "",
      Date: searchData.Date,
      WarehouseID: searchData.WarehouseID
    };
    const subParams = ["Search", "ClientID", "ClientName", "Date", "WarehouseID"];

    return this.getSummary_createTransRow(
      access.RtnInvoice_Act_List, AppModule.RtnInvoice.FullName, AppModule.RtnInvoice,
      transSummary.AddTotal, null, null,
      transSummary.SubTotal, subSearch, subParams
    );
  },
  getSummary_getRtnInvoice_hppTotal(summaryObj, access, searchData) {
    const transSummary = summaryObj[AppModule.RtnInvoice.Code + "HppTotal"];

    const addSearch = {
      Search: "",
      Client: "",
      ClientID: null,
      Date: searchData.Date,
      Status: App.Search.OptionAll,
      WarehouseID: searchData.WarehouseID,
      RecordTypeID: App.Search.OptionAll
    };
    const addParams = ["Search", "Client", "ClientID", "Date", "Status",
      "WarehouseID", "RecordTypeID"
    ];

    return this.getSummary_createTransRow(
      access.RtnInvoice_Act_List, Info.Transaction.RtnInvoiceHpp, AppModule.RtnInvoice, 
      transSummary.AddTotal, addSearch, addParams,
      transSummary.SubTotal, null, null
    );
  },
  getSummary_getExpense(summaryObj, access, searchData) {
    const transSummary = summaryObj[AppModule.Expense.Code];

    const subSearch = {
      Search: "",
      Date: searchData.Date,
      PaymentTypeName: App.Search.OptionAll,
      SubCategoryID: App.Search.OptionAll,
      WarehouseID: searchData.WarehouseID
    };
    const subParams = ["Search", "Date", "PaymentTypeName", "SubCategoryID", 
      "WarehouseID"
    ];

    return this.getSummary_createTransRow(
      access.Expenses_Act_List, AppModule.Expense.FullName, AppModule.Expense,
      transSummary.AddTotal, null, null,
      transSummary.SubTotal, subSearch, subParams
    );
  },
  getSummary_getStockReduction(summaryObj, access, searchData) {
    const transSummary = summaryObj[AppModule.StockReduction.Code];

    const subSearch = {
      Search: "",
      Date: searchData.Date,
      WarehouseID: searchData.WarehouseID
    };
    const subParams = ["Search", "Date", "WarehouseID"];

    return this.getSummary_createTransRow(
      access.StockReduction_Act_List, AppModule.StockReduction.FullName,
      AppModule.StockReduction, transSummary.AddTotal, null, null,
      transSummary.SubTotal, subSearch, subParams
    );
  },
  getSummary_getStockTrf(summaryObj, access, searchData) {
    const transSummary = summaryObj[AppModule.StockTrf.Code];

    const addSearch = {
      Search: "",
      Date: searchData.Date,
      SourceWarehouseID: App.Search.OptionAll,
      DestinationWarehouseID: searchData.WarehouseID
    };

    const subSearch = {
      Search: "",
      Date: searchData.Date,
      SourceWarehouseID: searchData.WarehouseID,
      DestinationWarehouseID: App.Search.OptionAll
    };

    const params = ["Search", "Date", "SourceWarehouseID",
      "DestinationWarehouseID"
    ];

    return this.getSummary_createTransRow(
      access.StockTrf_Act_List, AppModule.StockTrf.FullName, AppModule.StockTrf,
      transSummary.AddTotal, addSearch, params,
      transSummary.SubTotal, subSearch, params
    );
  },
  getSummary_createTransRow(hasAccess, moduleName, module, addTotal,
    addSearch, addParams, subTotal, subSearch, subParams
  ) {
    return {
      HasAccess: hasAccess,
      Label: moduleName,
      Module: module,
      AddTotal: addTotal,
      AddSearch: addSearch,
      AddParams: addParams,
      SubTotal: subTotal,
      SubSearch: subSearch,
      SubParams: subParams
    };
  }
}